import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

// Return the native window obj
function _window(): any {
    return window;
}

@Injectable()
export class NewrelicService {

    constructor(private _httpClient: HttpClient) {}

    private static get nativeWindow(): any {
        return _window();
    }

    static URL = '/s-transfers/api/recordCustomEvent';
    static JSON_HEADERS: any = {
        'Content-Type': 'application/json'
    };

    private eventPrefix: string;

    public static noticeError(error, customAttributes?): void {
        try {
            NewrelicService.nativeWindow.newrelic.noticeError(error, customAttributes);
        } catch (e) {}
    }

    init(eventPrefix: string) {
        this.eventPrefix = eventPrefix;
    }

    trackToInsights(eventName: string, data: any = {}) {
        try {
            const url = `${NewrelicService.URL}/${this.eventPrefix + eventName}`;
            const headerValue: any = { ...NewrelicService.JSON_HEADERS, 'Content-Type': 'plain/text'};
            this._httpClient.post(url, JSON.stringify(data), {headers: headerValue}).subscribe();
        } catch (e) {}
    }
}
